
import { defineComponent, ComputedRef, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

export default defineComponent({
  setup() {
    const router = useRouter()
    const route = useRoute()

    const isOnTalk: ComputedRef<boolean> = computed(() => {
      return route.fullPath === router.resolve({ name: 'talk' }).href
    })

    return { isOnTalk, route }
  },
})
